import axios from 'axios';
import { User, Album, Song, Rating } from '../types';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (email: string, password: string) =>
    api.post<{ token: string; user: User }>('/auth/login', { email, password }),
  
  register: (email: string, password: string, role: string = 'listener') =>
    api.post('/auth/register', { email, password, role }),
};

export const albumsAPI = {
  getAll: () => api.get<Album[]>('/albums'),
  
  getById: (id: number) => api.get<Album>(`/albums/${id}`),
  
  create: (formData: FormData) =>
    api.post('/albums', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  update: (id: number, formData: FormData) =>
    api.put(`/albums/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  updateReleaseStatus: (id: number, is_released: boolean) =>
    api.put(`/albums/${id}/release`, { is_released }),
  
  updateVisibility: (id: number, is_hidden: boolean) =>
    api.put(`/albums/${id}/visibility`, { is_hidden }),
  
  delete: (id: number) => api.delete(`/albums/${id}`),
};

export const songsAPI = {
  getByAlbum: (albumId: number) => api.get<Song[]>(`/albums/${albumId}/songs`),
  
  getById: (id: number) => api.get<Song>(`/songs/${id}`),
  
  create: (albumId: number, formData: FormData) =>
    api.post(`/albums/${albumId}/songs`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  update: (id: number, formData: FormData) =>
    api.put(`/songs/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  rate: (songId: number, rating: number) =>
    api.post(`/songs/${songId}/rate`, { rating }),
  
  getRating: (songId: number) => api.get<Rating>(`/songs/${songId}/rating`),
};

export const usersAPI = {
  getAll: () => api.get<User[]>('/users'),
  
  updateRole: (id: number, role: string) =>
    api.put(`/users/${id}/role`, { role }),
  
  resetPassword: (id: number, password: string) =>
    api.put(`/users/${id}/password`, { password }),
  
  delete: (id: number) =>
    api.delete(`/users/${id}`),
};

export default api;